import { createSlice } from '@reduxjs/toolkit';

const selectedUserGroupSlice = createSlice({
  name: 'selectedUserGroup',
  initialState: {},
  reducers: {
    setUserGroup: (state, { payload }) => {
      return { ...payload };
    },
  },
});

export const { setUserGroup } = selectedUserGroupSlice.actions;
export default selectedUserGroupSlice.reducer;
